module.exports = __webpack_public_path__ + "static/sundar-pichai-1e32ceffc85f8af7d2bdda6ee9524fd4.jpg";